import * as React from 'react';

import { useDispatch } from 'react-redux'
import { setOperation } from '../operation/operationSlice';

import DataList from '../../components/controls/datagrid/DataList';
import DataColumn from '../../components/controls/datagrid/DataColumn';

export default (props: { controller: string, items: any }) => {
    const dispatch = useDispatch()
    const onRowClick = (e: any, data: any) => {
        e.preventDefault()
        dispatch(setOperation("read", props.controller, { index: data }))
    }

    return (
        <>
            <DataList items={props.items} onRowClick={onRowClick} >
                <DataColumn kid='column1' name='Codice' fieldName='code' minWidth={100} maxWidth={100} align='left' />
                <DataColumn kid='column2' name='Nome' fieldName='firstname' minWidth={150} maxWidth={300} align='left' />
                <DataColumn kid='column3' name='Cognome' fieldName='lastname' minWidth={150} maxWidth={300} align='left' />
                <DataColumn kid='column4' name='E-Mail' fieldName='email' minWidth={150} align='left' />
                <DataColumn kid='column5' name='Attivo' type="icon" fieldName='leap_ConsultantStateID' minWidth={50} maxWidth={50} align='center' />
                <DataColumn kid='column6' name='Tipo Gestione' fieldName='leap_ConsultantManagementTypeID' minWidth={100} maxWidth={100} align='left' />
            </DataList>
        </>
    );
}
